import classNames from "classnames";
import { BookingPill } from "PFApp/components/pills/booking_pill";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import useBookingCategories from "PFCore/hooks/use_booking_categories";
import { Id } from "PFCore/types";
import { getContrastingTextColor } from "PFCore/utilities/color";
import { validateCategoryIcon } from "PFModules/admin/booking/categories/booking_categories.utils";
import { AccessLevel } from "PFTypes";
import React from "react";

import css from "./booking_category_badge.module.scss";

type BookingCategoryBadgeProps = {
  categoryId?: Id | null;
  className?: string;
};

export const BookingCategoryBadge = ({ categoryId, className }: BookingCategoryBadgeProps) => {
  const { getBookingCategory } = useBookingCategories();
  const category = getBookingCategory(categoryId);
  const isHiddenCategory = !category || category.bookings_permissions === AccessLevel.Hidden;
  const fillColor = !isHiddenCategory ? getContrastingTextColor(category.color, 1).hex() : undefined;
  const categoryIcon = !isHiddenCategory ? validateCategoryIcon(category.icon) : "locked";

  // TODO: [SP-2975] Use Table component in BM Approvals tab
  // Use BookingPill logic to display category icon (svg fill is overwritten by a deprecated css)
  return (
    <BookingPill category={category} withCategoryIcon={false} className={classNames(css.root, className)}>
      {!!categoryIcon && (
        <Icon name={categoryIcon} size="xxs" style={{ fill: fillColor }} className={css.categoryIcon} />
      )}
      <Typography variant="labelRegular" clipOverflow title={category?.display_as}>
        {category?.display_as}
      </Typography>
    </BookingPill>
  );
};
